import React from "react";

export default function AdminTasksSummaryMobile() {
  return <div></div>;
}
